<template>
  <div id="insightsTeam">
    <div class="margin-subpages">
      <div class="flex">
        <el-select
          v-model="selectTeam"
          filterable
          placeholder="Select"
          class="input-style"
          :class="[ blurMode ?  'blurelement': '' ]"
          @change="changMainPageData"
        >
          <el-option
            v-if="user.user_type !== 'leadership'"
            class="text-dropdown"
            key="all"
            :label="`All Teams (${$utils(
              'addCommasInNumber',
              optionsTeam.length
            )})`"
            value="all"
          ></el-option>
          <el-option
            class="text-dropdown"
            :class="[ blurMode ?  'blurelement': '' ]"
            v-for="item in optionsTeam"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
      <div class="headerCard">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{
            $t("insights.HAPPINESS_VS_RISK_RATE")
          }}</span>
        </div>
        <div class="pr-12 mt-11">
          <span class="fc-4A4A4A">{{ $t("insights.Duration") }}</span>
        </div>
        <div class="showOption">
          <el-menu
            class="el-menu-demo menuOptionStyle"
            mode="horizontal"
            style="width: 200px"
          >
            <el-submenu index="0" style="width: 200px">
              <template slot="title">
                <span class="txtOption2">{{ selectMainPageMonth }}</span>
              </template>
              <el-menu-item
                index="1"
                @click="handleMainPageMonth('30-days')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_30_days") }}</el-menu-item
              >
              <el-menu-item
                index="2"
                @click="handleMainPageMonth('60-days')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_60_days") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('13-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_13_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('26-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_26_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('52-weeks')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_52_weeks") }}</el-menu-item
              >
              <el-menu-item
                index="3"
                @click="handleMainPageMonth('24-months')"
                class="is-active"
                style="font-size: 16px; width: 200px"
                >{{ $t("insights.Last_24_months") }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
        <div class="pl-10">
          <svg
            @click="exportChart('mainPage')"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
        </div>
      </div>
      <div class="chart-bar relative" style="height: 217px">
        <div class="loading-chart-bar flex-mid pt-1" v-if="loadingData">
          <loading-even></loading-even>
        </div>
        <div class="flex-mid" v-else>
          <div class="chart-type-bar green ml-16"></div>
          <div class="type-bar-text">{{ $t("insights.HAPPINESS") }}</div>
          <div class="chart-type-bar red"></div>
          <div class="type-bar-text">{{ $t("insights.RISK") }}</div>
          <div class="chart-type-bar line">
            <div></div>
          </div>
          <div class="type-bar-text">{{ $t("insights.ACTIVE_USERS") }}</div>
        </div>
        <div
          v-if="loadingData"
          class="absolute-mid"
          style="height: 197px; width: 100%"
        >
          <img
            class="absolute-mid"
            src="@/assets/images/insights/bar_chart_empty_state.png"
          />
        </div>
        <div
          v-else-if="!loadingData && Object.keys(this.datachart).length == 0"
          class="absolute-mid"
          style="height: 197px; width: 100%"
        >
          <img
            class="absolute-mid"
            src="@/assets/images/insights/bar_chart_empty_state.png"
          />
          <div class="absolute-mid center fs-12 fw-500" style="width: 100%">
            {{ $t("insights.There_is_no_happiness") }}
          </div>
        </div>
        <div style="height: 180px">
          <canvas ref="chartCurrent"></canvas>
        </div>
      </div>
      <div class="flex mt-26">
        <span class="txtHeaderCard">{{ $t("insights.SPOTLIGHT") }}</span>
      </div>
      <div class="flex" style="flex-direction: row">
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Engaged")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_with_highest_engagement") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostengageMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_engaged_at")
            }}</span>
          </div>
          <div v-else v-for="item in mostengageMain" :key="`MP-1-${item.no}`">
            <div class="SpotGroupBox"
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      item.team_name ? truncateText(item.team_name, 23) : "Top Most"
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Retention_Risks")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_with_highest_retention") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="retentionrisksMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_retention_risks_at")
            }}</span>
          </div>
          <div
            v-else
            v-for="item in retentionrisksMain"
            :key="`MP-2-${item.no}`"
          >
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Improved")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_that_show_the_most") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostimproveMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_improved_at")
            }}</span>
          </div>
          <div v-else v-for="item in mostimproveMain" :key="`MP-3-${item.no}`">
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Critical")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_that_are_most_critical") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostcriticalMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_critical")
            }}</span>
          </div>
          <div v-else v-for="item in mostcriticalMain" :key="`MP-4-${item.no}`">
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="headerCard2">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{ $t("insights.TEAM_STATUS") }}</span>
        </div>
        <div style="padding-right: 12px; margin-top: 10px">
          <span class="fc-4A4A4A">{{ $t("insights.Sort_by") }}</span>
        </div>
        <div class="showOption">
          <el-menu
            class="el-menu-demo menuOptionStyle"
            mode="horizontal"
            style="width: 200px"
          >
            <el-submenu :index="`${selectMainPageSort}`" style="width: 200px">
              <template slot="title">
                <span class="txtOption2">{{
                  optionsSort[selectMainPageSort]
                }}</span>
              </template>
              <el-menu-item
                v-for="(value, key) in optionsSort"
                :key="`MAIN_PAGE-${key}`"
                :index="`${key}`"
                @click="sortByMainPage"
                style="font-size: 16px; width: 200px"
                >{{ value }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="divTable" style="min-height: 300px">
        <el-table
          id="teamsTable"
          :data="realDataMainTreeTable"
          max-height="720"
          :empty-text="
            loadingDataListTable
              ? ' '
              : 'There is no data to display for the current time period.'
          "
          ref="teamsTable"
          style="width: 100%"
          :cell-style="cellStyle"
          row-key="id"
          lazy
          :expand-row-keys="expandkay"
          :load="load"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            :remote="remoteMainPage"
            label-class-name="labelTeamTable"
            class-name="cell-with-nowrap"
            :label="$t('insights.Team')"
          >
            <template slot-scope="scope">
                <span
                  class="text-open-modal"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="showModal(scope.row.id)"
                  >{{ scope.row.team }}</span
                >
            </template>
          </el-table-column>
          <!-- :label="$t('insights.Happi_Rate')" -->
          <el-table-column
            label="Happiness Rate"
            width="80"
            label-class-name="labelRateTable"
            class-name="line-break"
            align="right"
          >
          <template slot="header">
              <el-tooltip content="The rate of &quot;Very Happy&quot; or &quot;Pretty Good&quot; responses to the &quot;How do you feel today?&quot; daily pulse question" placement="top">
                <span>Happiness Rate</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.happirate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Risk_Rate')"
            width="58"
            align="right"
            label-class-name="labelRateTable"
            class-name="line-break"
          >
          <template slot="header">
              <el-tooltip content="The rate of &quot;Not Great&quot; or &quot;Terrible&quot; responses to the &quot;How do you feel today?&quot; daily pulse question" placement="top">
                <span>Risk Rate</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.riskrate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Feedback')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.feedback.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.feedback.score === 0 && scope.row.feedback.color === '#C7C7C7' ? '?' : Math.round(scope.row.feedback.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Wellness')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.wellness.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.wellness.score === 0 && scope.row.wellness.color === '#C7C7C7' ? '?' : Math.round(scope.row.wellness.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Manager')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.manager.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.manager.score === 0 && scope.row.manager.color === '#C7C7C7' ? '?' : Math.round(scope.row.manager.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Recognition')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="46"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.recognition.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.recognition.score === 0 && scope.row.recognition.color === '#C7C7C7' ? '?' : Math.round(scope.row.recognition.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Ambassadorship')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.ambassadorship.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.ambassadorship.score === 0 && scope.row.ambassadorship.color === '#C7C7C7' ? '?' : Math.round(scope.row.ambassadorship.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Colleagues')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.colleagues.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.colleagues.score === 0 && scope.row.colleagues.color === '#C7C7C7' ? '?' : Math.round(scope.row.colleagues.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Personal_Growth')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.personal.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.personal.score === 0 && scope.row.personal.color === '#C7C7C7' ? '?' : Math.round(scope.row.personal.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Co_Alignment')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.alignment.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.alignment.score === 0 && scope.row.alignment.color === '#C7C7C7' ? '?' : Math.round(scope.row.alignment.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Satisfaction')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.satisfaction.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.satisfaction.score === 0 && scope.row.satisfaction.color === '#C7C7C7' ? '?' : Math.round(scope.row.satisfaction.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="12">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="Avg Impact"
            width="62"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip content="The average impact rating score of team members, calculated as the sum of their individual impact scores divided by the number of members" placement="top">
                <span>Avg Impact</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-mid">
                <div
                  class="impact-tag px-2 fw-700"
                  :class="`impact-tag-${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ?  'gray' : scope.row.avgimpact_color}`"
                  style="line-height: 18px; font-size: 12px; width: 50px;"
                >
                {{
                  `${(scope.row.avgimpact == undefined) ? '-' : Math.round(scope.row.avgimpact)}`
                }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="DEBI Score"
            width="64"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
            <template slot="header">
              <el-tooltip content="The Dynamic Engagement Behavioral Index (DEBI) for each team is determined by several factors: the frequency of team members' check-ins and responses, the quality of their feedback, their activity in recognizing peers, and their alignment with the organization's core values." placement="top">
                <span>DEBI Score</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          ENGAGEMENT SCORE
                        </div>
                        <div class="fs-11 mt-4">
                          Dynamic Engagement Behavioral Index by role 
                        </div>
                          <div v-if="!loadingDataEngagement" style="justify-content: flex-start">
                            <div class="flex">
                              <div>
                                <div class="fs-12 chart-legend first">
                                  <div class="label">Overall</div>
                                  <div class="symbol blue"></div>
                                  <div class="score">{{ (databarchartEngagementScore['team'] && databarchartEngagementScore['team_members'] && databarchartEngagementScore['team_members'][databarchartEngagementScore['team_members'].length - 1] > 0) ? databarchartEngagementScore['team'][databarchartEngagementScore['team'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">Manager</div>
                                  <div class="symbol orange"></div>
                                  <div class="score">{{ (databarchartEngagementScore['manager'] && databarchartEngagementScore['manager_members'] && databarchartEngagementScore['manager_members'][databarchartEngagementScore['manager_members'].length - 1] > 0) ? databarchartEngagementScore['manager'][databarchartEngagementScore['manager'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">Leader</div>
                                  <div class="symbol pink"></div>
                                  <div class="score">{{ (databarchartEngagementScore['leader'] && databarchartEngagementScore['leader_members'] && databarchartEngagementScore['leader_members'][databarchartEngagementScore['leader_members'].length - 1] > 0) ? databarchartEngagementScore['leader'][databarchartEngagementScore['leader'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingDataEngagement"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="`engagement_${scope.row.id}`"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainEngagementTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${detectColorTotal(scope.row.engagement_score)}`"
                    style="line-height: 18px; font-size: 12px; width: 50px; margin-left: 14px;"
                  >
                  {{
                  `${(scope.row.engagement_score !== undefined && !isNaN(scope.row.engagement_score)) ? Math.round(scope.row.engagement_score) : scope.row.engagement_score}`
                  }}
                  </div>
               
                </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="6-mo Retention"
            width="68"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip content="The retention rate of team members over a 6-month period, calculated as the percentage of members who remain in the team after 6 months" placement="top">
                <span>6-mo Retention</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          ARCHIVED MEMBERS HISTORY
                        </div>
                        <div class="fs-11 mt-4">
                          Number of archived members by month
                        </div>
                      </div>
                      <div class="ml-auto fs-11">
                        <div class="flex-center">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #ffbcb7;
                            "
                          >
                            &nbsp;
                          </div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                            Terminated
                          </div>
                        </div>
                        <div class="flex-center mt-4">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #f44336;
                            "
                          >
                            &nbsp;
                          </div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">Resigned</div>
                        </div>
                      </div>
                    </div>
                    <div class="pt-20 relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingChartInTable"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="scope.row.id"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ?  'gray' : scope.row.retention_color}`"
                    style="line-height: 18px; font-size: 12px; width: 50px"
                  >
                  {{
                  `${(scope.row.retention_rate == undefined) ? '-' : Math.round(scope.row.retention_rate) + '%'}`
                  }}
                  </div>
               
                </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="6">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
        </el-table>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingMainData">
          <loading-even></loading-even>
        </div>
      </div>
    </div>
    <div id="teamModal">
      <el-dialog top="10vh" :visible.sync="spotlightTeamStatus">
        <div class="px-32 py-24 modal-header"
        :class="[ blurMode ?  'blurelement': '' ]">
          {{ findTeamNameByKey(modalTitle) }}
        </div>
        <div class="px-32 pb-24">
          <div class="flex-mid pt-20">
            <div class="flex-1">
              <span class="txtHeaderCard">HEALTH OVERVIEW</span>
            </div>
            <div class="pr-12">
              <span class="fc-4A4A4A">{{ $t("insights.Duration") }}</span>
            </div>
            <div class="showOption">
              <el-menu
                class="el-menu-demo menuOptionStyle"
                mode="horizontal"
                style="width: 200px"
              >
                <el-submenu index="0" style="width: 200px">
                  <template slot="title">
                    <span class="txtOption2">{{ selectModalMonth }}</span>
                  </template>
                  <el-menu-item
                    index="1"
                    class="is-active"
                    @click="handleModalMonth('30-days')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_30_days") }}</el-menu-item
                  >
                  <el-menu-item
                    index="2"
                    class="is-active"
                    @click="handleModalMonth('60-days')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_60_days") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('13-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_13_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('26-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_26_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('52-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_52_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('24-months')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_24_months") }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
            <div class="pl-10">
              <img
                @click="exportChart('modal')"
                :src="$utils('icons', 'ic_xls_download')"
                class="mt-3 icon-export"
              />
            </div>
          </div>
          <div class="chart-bar relative">
            <div
              class="loading-chart-bar flex-mid pt-8"
              v-if="loadingDataModal"
            >
              <loading-even></loading-even>
            </div>
            <div class="flex-mid" v-else-if="chartInModalNodataStatus">
              No data.
            </div>
            <div class="flex-mid" v-else>
              <div class="chart-type-bar green"></div>
              <div class="type-bar-text">{{ $t("insights.HAPPINESS") }}</div>
              <div class="chart-type-bar red"></div>
              <div class="type-bar-text">{{ $t("insights.RISK") }}</div>
              <div class="chart-type-bar line">
                <div></div>
              </div>
              <div class="type-bar-text">{{ $t("insights.ACTIVE_USERS") }}</div>
            </div>
            <div
              v-if="
                !loadingDataModal &&
                Object.keys(this.dataBarChartModal).length == 0
              "
              class="absolute-mid"
              style="height: 197px; width: 100%"
            >
              <img
                class="absolute-mid"
                src="@/assets/images/insights/bar_chart_empty_state.png"
              />
              <div class="absolute-mid center fs-12 fw-500" style="width: 100%">
                {{ $t("insights.There_is_no_happiness") }}
              </div>
            </div>
            <div>
              <div style="height: 180px">
                <canvas ref="chartBarModal"></canvas>
              </div>
              <div class="pb-18 pt-12" style="height: 180px">
                <canvas ref="chartLineModal"></canvas>
              </div>
            </div>
          </div>
          <div class="flex mt-26">
            <span class="txtHeaderCard">{{ $t("insights.SPOTLIGHT") }}</span>
          </div>

          <div class="flex" style="flex-direction: row">
            <div class="SpotBox mr-16">
              <div class="flex-between">
                <div>
                  <span class="txt-spot-card">{{
                    $t("insights.Most_Engaged")
                  }}</span>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Teams_with_highest_engagement") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div v-if="mostengageModal.length == 0" style="padding-top: 14px">
                <span class="noDataTextStyle">{{
                  $t("insights.No_most_engaged_at")
                }}</span>
              </div>
              <div
                v-else
                v-for="item in mostengageModal"
                :key="`MD-1-${item.no}`"
              >
                <div
                  class="SpotGroupBox"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="handleTeamsModal(item.teamid)"
                >
                  <div class="flex-between">
                    <div
                      style="
                        overflow: hidden;
                        padding-left: 12px;
                        padding-top: 8px;
                      "
                    >
                      <div>
                        <span class="txtHeaderSpot">{{
                          truncateText(item.team, 20)
                        }}</span>
                      </div>
                      <div style="margin-top: -4px">
                        <span class="txtDetailSpot">{{
                          truncateText(item.team_name, 23)
                        }}</span>
                      </div>
                    </div>
                    <div class="flex-center my-14 mr-12 ml-5">
                      <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="SpotBox mr-16">
              <div class="flex-between">
                <div>
                  <span class="txt-spot-card">{{
                    $t("insights.Retention_Risks")
                  }}</span>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Teams_with_highest_retention") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div
                v-if="retentionrisksModal.length == 0"
                style="padding-top: 14px"
              >
                <span class="noDataTextStyle">{{
                  $t("insights.No_retention_risks_at")
                }}</span>
              </div>
              <div
                v-else
                v-for="item in retentionrisksModal"
                :key="`MD-2-${item.no}`"
              >
                <div
                  class="SpotGroupBox"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="handleTeamsModal(item.teamid)"
                >
                  <div class="flex-between">
                    <div
                      style="
                        overflow: hidden;
                        padding-left: 12px;
                        padding-top: 8px;
                      "
                    >
                      <div>
                        <span class="txtHeaderSpot">{{
                          truncateText(item.team, 20)
                        }}</span>
                      </div>
                      <div style="margin-top: -4px">
                        <span class="txtDetailSpot">{{
                          truncateText(item.team_name, 23)
                        }}</span>
                      </div>
                    </div>
                    <div class="flex-center my-14 mr-12 ml-5">
                      <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="SpotBox mr-16">
              <div class="flex-between">
                <div>
                  <span class="txt-spot-card">{{
                    $t("insights.Most_Improved")
                  }}</span>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Teams_that_show_the_most") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div
                v-if="mostimproveModal.length == 0"
                style="padding-top: 14px"
              >
                <span class="noDataTextStyle">{{
                  $t("insights.No_most_improved_at")
                }}</span>
              </div>
              <div
                v-else
                v-for="item in mostimproveModal"
                :key="`MD-3-${item.no}`"
              >
                <div
                  class="SpotGroupBox"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="handleTeamsModal(item.teamid)"
                >
                  <div class="flex-between">
                    <div
                      style="
                        overflow: hidden;
                        padding-left: 12px;
                        padding-top: 8px;
                      "
                    >
                      <div>
                        <span class="txtHeaderSpot">{{
                          truncateText(item.team, 20)
                        }}</span>
                      </div>
                      <div style="margin-top: -4px">
                        <span class="txtDetailSpot">{{
                          truncateText(item.team_name, 23)
                        }}</span>
                      </div>
                    </div>
                    <div class="flex-center my-14 mr-12 ml-5">
                      <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="SpotBox">
              <div class="flex-between">
                <div>
                  <span class="txt-spot-card">{{
                    $t("insights.Most_Critical")
                  }}</span>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Teams_that_are_most_critical") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div
                v-if="mostcriticalModal.length == 0"
                style="padding-top: 14px"
              >
                <span class="noDataTextStyle">{{
                  $t("insights.No_most_critical")
                }}</span>
              </div>
              <div
                v-else
                v-for="item in mostcriticalModal"
                :key="`MD-4-${item.no}`"
              >
                <div
                  class="SpotGroupBox"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="handleTeamsModal(item.teamid)"
                >
                  <div class="flex-between">
                    <div
                      style="
                        overflow: hidden;
                        padding-left: 12px;
                        padding-top: 8px;
                      "
                    >
                      <div>
                        <span class="txtHeaderSpot">{{
                          truncateText(item.team, 20)
                        }}</span>
                      </div>
                      <div style="margin-top: -4px">
                        <span class="txtDetailSpot">{{
                          truncateText(item.team_name, 23)
                        }}</span>
                      </div>
                    </div>
                    <div class="flex-center my-14 mr-12 ml-5">
                      <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="headerCard2">
            <div class="flex-1 mt-10">
              <span class="txtHeaderCard">{{
                $t("insights.TEAM_STATUS")
              }}</span>
            </div>
            <div style="padding-right: 12px; margin-top: 10px">
              <span class="fc-4A4A4A">{{ $t("insights.Sort_by") }}</span>
            </div>
            <div class="showOption">
              <el-menu
                class="el-menu-demo menuOptionStyle"
                mode="horizontal"
                style="width: 200px"
              >
                <el-submenu :index="`${selectModalSort}`" style="width: 200px">
                  <template slot="title">
                    <span class="txtOption2">{{
                      optionsSort[selectModalSort]
                    }}</span>
                  </template>
                  <el-menu-item
                    v-for="(value, key) in optionsSort"
                    :key="`MODAL-${key}`"
                    :index="`${key}`"
                    @click="sortByModal"
                    style="font-size: 16px; width: 200px"
                    >{{ value }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <div class="divTable" style="min-height: 300px">
            <el-table
              id="teamsTable"
              :data="realDataModalTreeTable"
              :empty-text="
                loadingDataListTable
                  ? ' '
                  : 'There is no data to display for the current time period.'
              "
              ref="teamsTable"
              style="width: 100%"
              :cell-style="cellStyle"
              row-key="id"
              lazy
              :expand-row-keys="expandkay"
              :load="loadModal"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                :remote="remoteMainPage"
                label-class-name="labelTeamTable"
                class-name="cell-with-nowrap"
                :label="$t('insights.Team')"
              >
                <template slot-scope="scope">
                  <span
                    class="text-open-modal ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    @click="showModal(scope.row.id)"
                    >{{ scope.row.team }}</span
                  >
                </template>
              </el-table-column>
              <!-- :label="$t('insights.Happi_Rate')" -->
              <el-table-column
                label="Happiness Rate"
                width="80"
                label-class-name="labelRateTable"
                class-name="line-break"
                align="right"
              >
                <template slot-scope="scope">{{
                  `${scope.row.happirate}%`
                }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Risk_Rate')"
                width="58"
                align="right"
                label-class-name="labelRateTable word-break"
                class-name="line-break"
              >
                <template slot-scope="scope">{{
                  `${scope.row.riskrate}%`
                }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Feedback')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.feedback.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.feedback.score === 0 && scope.row.feedback.color === '#C7C7C7' ? '?' : Math.round(scope.row.feedback.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Wellness')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.wellness.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.wellness.score === 0 && scope.row.wellness.color === '#C7C7C7' ? '?' : Math.round(scope.row.wellness.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Rel_Manager')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="45"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.manager.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.manager.score === 0 && scope.row.manager.color === '#C7C7C7' ? '?' : Math.round(scope.row.manager.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Recognition')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="46"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.recognition.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.recognition.score === 0 && scope.row.recognition.color === '#C7C7C7' ? '?' : Math.round(scope.row.recognition.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Ambassadorship')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.ambassadorship.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.ambassadorship.score === 0 && scope.row.ambassadorship.color === '#C7C7C7' ? '?' : Math.round(scope.row.ambassadorship.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Rel_Colleagues')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.colleagues.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.colleagues.score === 0 && scope.row.colleagues.color === '#C7C7C7' ? '?' : Math.round(scope.row.colleagues.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Personal_Growth')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.personal.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.personal.score === 0 && scope.row.personal.color === '#C7C7C7' ? '?' : Math.round(scope.row.personal.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Co_Alignment')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.alignment.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.alignment.score === 0 && scope.row.alignment.color === '#C7C7C7' ? '?' : Math.round(scope.row.alignment.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Satisfaction')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.satisfaction.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.satisfaction.score === 0 && scope.row.satisfaction.color === '#C7C7C7' ? '?' : Math.round(scope.row.satisfaction.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label label-class-name="labelTable" width="12">
                <template>
                  <div class="flexCenter"></div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="Avg Impact"
                width="52"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
              <template slot-scope="scope">
                  <div class="flex-center">
                    <div
                      class="impact-tag px-2 fw-700"
                      :class="`impact-tag-${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ?  'gray' : scope.row.avgimpact_color}`"
                      style="line-height: 18px; font-size: 12px; width: 50px;"
                    >
                    {{
                      `${(scope.row.avgimpact == undefined) ? '-' : scope.row.avgimpact}`
                    }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="DEBI Score"
                width="68"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
                <template slot-scope="scope">
                  <el-tooltip effect="light" :disabled="false">
                    <div slot="content">
                      <div
                        :class="`content-container-insightsReport`"
                        :style="`width: 325px;`"
                      >
                        <div class="flex-center fs-11">
                          <div>
                            <div class="fw-900 fc-2B2B2B mr-auto">
                              ENGAGEMENT SCORE
                            </div>
                            <div class="fs-11 mt-4">
                              Dynamic Engagement Behavioral Index by role
                            </div>
                              <div v-if="!loadingDataEngagementModal" style="justify-content: flex-start">
                                <div class="flex">
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Overall</div>
                                      <div class="symbol blue"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['team'] && databarchartEngagementScoreModal['team_members'] && databarchartEngagementScoreModal['team_members'][databarchartEngagementScoreModal['team_members'].length - 1] > 0) ? databarchartEngagementScoreModal['team'][databarchartEngagementScoreModal['team'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Manager</div>
                                      <div class="symbol orange"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['manager'] && databarchartEngagementScoreModal['manager_members'] && databarchartEngagementScoreModal['manager_members'][databarchartEngagementScoreModal['manager_members'].length - 1] > 0) ? databarchartEngagementScoreModal['manager'][databarchartEngagementScoreModal['manager'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Leader</div>
                                      <div class="symbol pink"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['leader'] && databarchartEngagementScoreModal['leader_members'] && databarchartEngagementScoreModal['leader_members'][databarchartEngagementScoreModal['leader_members'].length - 1] > 0) ? databarchartEngagementScoreModal['leader'][databarchartEngagementScoreModal['leader'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="relative" style="height: 140px">
                          <div
                            class="center mt-10 mb-40 pt-10 pb-40"
                            v-if="loadingDataEngagementModal"
                          >
                            <loading-even></loading-even>
                          </div>
                          <canvas
                            :ref="`engagement_modal_${scope.row.id}`"
                            height="120px;"
                            class=""
                          ></canvas>
                        </div>
                        <div class="fs-11 fc-2B2B2B opa-03 right">
                          {{ $t("insights.Most_Recent") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-center cursor-pointer"
                      @mouseover.prevent="showingHistoryModalEngagementTable(scope.row)"
                    >
                      <div
                        class="impact-tag ml-auto fw-700"
                        :class="`impact-tag-${detectColorTotal(scope.row.engagement_score)}`"
                        style="line-height: 18px; font-size: 12px; width: 50px; margin-left: 14px;"
                      >
                      {{
                      `${scope.row.engagement_score}`
                      }}
                      </div>
                  
                    </div>
                  </el-tooltip>
                  
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="6-mo Retention"
                width="68"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
                <template slot-scope="scope">
                  <el-tooltip effect="light" :disabled="false">
                    <div slot="content">
                      <div
                        :class="`content-container-insightsReport`"
                        :style="`width: 325px;`"
                      >
                        <div class="flex-center fs-11">
                          <div>
                            <div class="fw-900 fc-2B2B2B mr-auto">
                              ARCHIVED MEMBERS HISTORY
                            </div>
                            <div class="fs-11 mt-4">
                              Number of archived members by month
                            </div>
                          </div>
                          <div class="ml-auto fs-11">
                            <div class="flex-center">
                              <div
                                style="
                                  width: 18px;
                                  height: 14px;
                                  background: #ffbcb7;
                                "
                              >
                                &nbsp;
                              </div>
                              <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                                Terminated
                              </div>
                            </div>
                            <div class="flex-center mt-4">
                              <div
                                style="
                                  width: 18px;
                                  height: 14px;
                                  background: #f44336;
                                "
                              >
                                &nbsp;
                              </div>
                              <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                                Resigned
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pt-20 relative" style="height: 140px">
                          <div
                            class="center mt-10 mb-40 pt-10 pb-40"
                            v-if="loadingChartInTable"
                          >
                            <loading-even></loading-even>
                          </div>
                          <canvas
                            :ref="'modal_' + scope.row.id"
                            height="120px;"
                            class=""
                          ></canvas>
                        </div>
                        <div class="fs-11 fc-2B2B2B opa-03 right">
                          {{ $t("insights.Most_Recent") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-center cursor-pointer"
                      @mouseover.prevent="showingHistoryModalTable(scope.row)"
                    >
                      <div
                        class="impact-tag ml-auto fw-700"
                        :class="`impact-tag-${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ?  'gray' : scope.row.retention_color}`"
                        style="line-height: 18px; font-size: 12px; width: 50px;"
                      >
                        {{
                        `${(scope.row.retention_rate == undefined) ? '-' : scope.row.retention_rate}`
                        }}
                      </div>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label label-class-name="labelTable" width="6">
                <template>
                  <div class="flexCenter"></div>
                </template>
              </el-table-column>
            </el-table>
            <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingModalData">
              <loading-even></loading-even>
            </div>
            <download-progress
              :wording="wordingSnackBar"
              :active="showSnackbar"
            ></download-progress>
          </div>
        </div>
      </el-dialog>
      <download-progress
        :wording="wordingSnackBar"
        :active="showSnackbar"
      ></download-progress>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js/auto";
import chartDataResignedLabels from "chartjs-plugin-datalabels";
import { isArray } from "util";
import subMonths from "date-fns/sub_months";
import getDaysInMonth from "date-fns/get_days_in_month";
import setDay from "date-fns/set_day";
import getDay from "date-fns/get_day";
import addDays from "date-fns/add_days";
import addMonths from "date-fns/add_months";
import startOfWeek from "date-fns/start_of_week";
import subWeeks from "date-fns/sub_weeks";
import lastDayOfWeek from "date-fns/last_day_of_week";
// var startOfWeek = require('date-fns/start_of_week')

export default {
  name: "teams",
  name: "standard",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    let team = "all";
    if (this.user.user_type == "leadership") {
      team = this.user.team;
    }
    this.$store.dispatch("teams/getTeamArr", this.user);
    this.$store.dispatch("teams/getTeamOrganization1level", this.user);
    this.$store.dispatch("teams/getOrganization");
    this.$store.commit("teams/setDataTable", []);
    this.$store.dispatch("team/getTeamsOptions", this.user);

    
    if (this.expandProps.navCall) {
      team = this.expandProps.memberObject.key;
      this.selectTeam = team;
      this.selectMainPageMonth = this.expandProps.expandTime.key;
      this.$store.commit("teams/setTeam", team);
      this.$store.dispatch("teams/getInsightTeams", {
        selectTeam: team,
        activeWhere: {},
      });
      this.$store.dispatch("teams/getInsightTeamsByComp");

    } else {
      this.$store.commit(
        "teams/setTeam",
        this.user.user_type == "leadership" ? team : "all"
      );
      this.$store.dispatch("teams/getInsightTeams", {
        selectTeam: this.user.user_type == "leadership" ? team : "",
        activeWhere: {},
      });
      this.$store.dispatch("teams/getInsightTeamsByComp");
    }
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    expandProps() {
      return this.$store.getters["navCommands/getExpandProps"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsall"];
    },
    getInsightTeams() {
      return this.$store.getters["teams/insightteams"];
    },
    getInsightTeamsModal() {
      return this.$store.getters["teams/insightteamsModal"];
    },
    datachart() {
      return this.$store.getters["teams/datachart"];
    },
    dataBarChartModal() {
      return this.$store.getters["teams/datachartModal"];
    },
    datalist() {
      return this.$store.getters["teams/datalist"];
    },
    datalistModal() {
      return this.$store.getters["teams/datalistModal"];
    },
    loadingDataModal() {
      return this.$store.getters["teams/loadingDataModal"];
    },
    loadingData() {
      return this.$store.getters["teams/loadingData"];
    },
    loadingDataListTable() {
      this.dataAllList = this.datalist;
      this.dataAllListModal = this.datalistModal;
      this.dataMainTreeTable();
      this.dataModalTreeTable();
      return this.$store.getters["teams/dataListLoading"];
    },
    mostengage() {
      return this.$store.getters["teams/mostengage"];
    },
    mostengageModal() {
      return this.$store.getters["teams/mostengageModal"];
    },
    retentionrisks() {
      return this.$store.getters["teams/retentionrisks"];
    },
    retentionrisksModal() {
      return this.$store.getters["teams/retentionrisksModal"];
    },
    mostimprove() {
      return this.$store.getters["teams/mostimprove"];
    },
    mostimproveModal() {
      return this.$store.getters["teams/mostimproveModal"];
    },
    mostcritical() {
      return this.$store.getters["teams/mostcritical"];
    },
    mostcriticalModal() {
      return this.$store.getters["teams/mostcriticalModal"];
    },
    showSnackbar() {
      return this.$store.getters["teams/showSnackbar"];
    },
    loadingDataEngagement() {
      return this.$store.getters["teams/loadingDataEngagement"];
    },
    loadingDataEngagementModal() {
      return this.$store.getters["teams/loadingDataEngagementModal"];
    },
    databarchartEngagementScore() {
      return this.$store.getters["teams/databarchartEngagementScore"];
    },
    databarchartEngagementScoreModal() {
      return this.$store.getters["teams/databarchartEngagementScoreModal"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  data() {
    return {
      wordingSnackBar: "Preparing team data, please wait...",
      activeWhere: {},
      activeWhereModal: {},
      expands: [],
      hoverTeam: "",
      hoverModalTeam: "",
      selectTeam: "",
      selectTeamModal: "",
      selectMainPageMonth: "60-days",
      selectModalMonth: "60-days",
      optionsMainPageMonthName: [],
      optionsMainPageMonth: [],
      optionsModalMonthName: [],
      optionsModalMonth: [],
      myChart: "",
      myModalBarChart: "",
      myModalLineChart: "",
      optionsSort: [],
      selectModalSort: 0,
      selectMainPageSort: 0,
      spotlightTeamStatus: false,
      dataAllList: [],
      dataAllListModal: [],
      teamStatusChanged: true,
      modalTitle: "",
      dataMainPageChanged: true,
      mostengageMain: [],
      retentionrisksMain: [],
      mostimproveMain: [],
      mostcriticalMain: [],
      // loadingModalChartStatus: true,
      newLabels: [],
      newLabelsfulldate: [],
      newLabelsModal: [],
      newLabelsModalfulldate: [],
      realDataMainTreeTable: [],
      realDataModalTreeTable: [],
      expandkay: [],
      chartInModalNodataStatus: false,
      loadingMainData: true,
      loadingModalData: true,
      loadingChartInTable: false,
      barChartTooltipBarChartOnMain: null,
      barChartTooltipBarChartOnModal: null,
      barChartTooltipBarChartOnMainEngagement: null,
      barChartTooltipBarChartOnModalEngagement: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
        this.handleModalMonth(this.selectModalMonth);
        this.handleMainPageMonth(this.selectMainPageMonth);
        if (this.optionsTeam.length > 0 && this.selectTeam == "") {
          this.selectTeam =
            this.user.user_type == "leadership" ? this.user.team : "all";
        }
        this.setDefault();
    });
    this.optionsSort.push(this.$t("insights.Lowest_Happiness"));
    this.optionsSort.push(this.$t("insights.Highest_Happiness"));
    this.optionsSort.push(this.$t("insights.Lowest_Risk"));
    this.optionsSort.push(this.$t("insights.Highest_Risk"));
  },
  watch: {
    databarchartEngagementScore() {
      if (this.barChartTooltipBarChartOnMainEngagement)
        this.barChartTooltipBarChartOnMainEngagement.destroy();
      this.generateChartTooltipOnMainEngagement();
    },
    databarchartEngagementScoreModal() {
      if (this.barChartTooltipBarChartOnModalEngagement)
        this.barChartTooltipBarChartOnModalEngagement.destroy();
      this.generateChartTooltipOnModalEngagement();
    },
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    datachart() {
      if (this.myChart && this.dataMainPageChanged) {
        this.myChart.destroy();
      }
      if (Object.keys(this.datachart).length > 0) {
        this.randerMainPageChart();
      }
    },
    dataBarChartModal() {
      if (this.myModalBarChart) {
        this.myModalBarChart.destroy();
      }
      if (this.myModalLineChart) {
        this.myModalLineChart.destroy();
      }
      if (Object.keys(this.dataBarChartModal).length > 0) {
        this.randerBarChartModal();
        this.randerLineChartModal();
      }
    },
    mostcritical() {
      if (this.teamStatusChanged === true) {
        this.mostengageMain = this.mostengage;
        this.retentionrisksMain = this.retentionrisks;
        this.mostimproveMain = this.mostimprove;
        this.mostcriticalMain = this.mostcritical;
        this.teamStatusChanged = false;
      }
    },
  },
  methods: {
    setDefault() {
      this.mostengageMain = this.mostengage;
    },
    randerMainPageChart() {
      var chart = this.$refs.chartCurrent;
      var ctx = chart.getContext("2d");
      if (this.expandProps.navCall && this.myChart) {
        this.myChart.destroy();
      }
      if ((this.dataMainPageChanged && this.datachart.happy) || this.expandProps.navCall) {
        let maxRiskLevel = -20;
        for (let i = 0; i < this.datachart.risk.length; i++) {
          if (this.datachart.risk[i] > 0) {
            this.datachart.risk[i] = this.datachart.risk[i] * -1;
          }
          if (this.datachart.risk[i] < maxRiskLevel) {
            maxRiskLevel = this.datachart.risk[i];
          }
        }
        const backgroundColorBar = [];
        const borderColorBar = [];
        for (let i = 0; i < this.datachart.activeuser.length; i++) {
          if (this.datachart.happy[i] === 0 && this.datachart.risk[i] === 0) {
            this.datachart.happy[i] = 2;
            borderColorBar.push("#747474");
            backgroundColorBar.push("#747474");
          } else {
            borderColorBar.push("#66BB6A");
            backgroundColorBar.push("#66BB6A98");
          }
        }
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: maxRiskLevel,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.8,
            borderRadius: 2,
            borderSkipped: true,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabels[tooltipItems[0].dataIndex];
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              let value = tooltipItems.formattedValue;
              if (value < 0) {
                value = value * -1;
              }
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.allUser[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people})`;
              } else if (
                tooltipItems.datasetIndex == 1 &&
                tooltipItems.dataset.backgroundColor[tooltipItems.dataIndex] ==
                  "#747474"
              ) {
                value = "0";
              }
              return `${label}: ${value}%`;
            },
          },
        };
        this.myChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.optionsMainPageMonthName,
            datasets: [
              {
                label: this.$t("insights.ACTIVE_USERS"),
                data: this.datachart.activeuser,
                allUser: this.datachart.alluser,
                backgroundColor: "#6C30CC",
                borderColor: "#6C30CC",
                stack: "combined",
                borderWidth: 1,
                pointRadius: 0,
                pointBorderWidth: 0,
              },
              {
                label: this.$t("insights.HAPPINESS"),
                data: this.datachart.happy,
                backgroundColor: backgroundColorBar,
                borderColor: borderColorBar,
                borderWidth: 1,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
              {
                label: this.$t("insights.RISK"),
                data: this.datachart.risk,
                backgroundColor: "#F4433699",
                borderColor: "#F44336",
                borderWidth: 1,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
            ],
          },
          options: options,
        });
        this.dataMainPageChanged = false;
      }
    },
    randerBarChartModal() {
      let maxRiskLevel = -20;
      var chart = this.$refs.chartBarModal;
      if (chart) {
        if (this.dataBarChartModal.risk) {
          for (let i = 0; i < this.dataBarChartModal.risk.length; i++) {
            if (this.dataBarChartModal.risk[i] > 0) {
              this.dataBarChartModal.risk[i] =
                this.dataBarChartModal.risk[i] * -1;
            }
            if (this.dataBarChartModal.risk[i] < maxRiskLevel) {
              maxRiskLevel = this.dataBarChartModal.risk[i];
            }
          }
        }
        const backgroundColorBar = [];
        const borderColorBar = [];
        for (let i = 0; i < this.dataBarChartModal.activeuser.length; i++) {
          if (
            this.dataBarChartModal.happy[i] === 0 &&
            this.dataBarChartModal.risk[i] === 0
          ) {
            this.dataBarChartModal.happy[i] = 2;
            borderColorBar.push("#747474");
            backgroundColorBar.push("#747474");
          } else {
            borderColorBar.push("#66BB6A");
            backgroundColorBar.push("#66BB6A98");
          }
        }
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: maxRiskLevel,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.8,
            borderRadius: 2,
            borderSkipped: true,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabelsModal[tooltipItems[0].dataIndex];
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              let value = tooltipItems.formattedValue;
              if (value < 0) {
                value = value * -1;
              }
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.allUser[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people})`;
              } else if (
                tooltipItems.datasetIndex == 1 &&
                tooltipItems.dataset.backgroundColor[tooltipItems.dataIndex] ==
                  "#747474"
              ) {
                value = "0";
              }
              return `${label}: ${value}%`;
            },
          },
        };
        // this.loadingModalChartStatus = false;
        var ctx = chart.getContext("2d");
        this.myModalBarChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.optionsModalMonthName,
            datasets: [
              {
                label: this.$t("insights.ACTIVE_USERS"),
                data: this.dataBarChartModal.activeuser,
                allUser: this.dataBarChartModal.alluser,
                backgroundColor: "#6C30CC",
                borderColor: "#6C30CC",
                stack: "combined",
                borderWidth: 1,
                pointBorderWidth: 1,
                pointHoverRadius: 0,
                pointRadius: 0,
              },
              {
                label: this.$t("insights.HAPPINESS"),
                data: this.dataBarChartModal.happy,
                backgroundColor: backgroundColorBar,
                borderColor: borderColorBar,
                borderWidth: 1,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
              {
                label: this.$t("insights.RISK"),
                data: this.dataBarChartModal.risk,
                backgroundColor: "#F4433699",
                borderColor: "#F44336",
                borderWidth: 1,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
            ],
          },
          options: options,
        });
        this.chartInModalNodataStatus = false; // Show UI no data on here!
      } else {
        // this.loadingModalChartStatus = false;
      }
    },
    randerLineChartModal() {
      var chart = this.$refs.chartLineModal;
      if (chart) {
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            // stacked: true,
            max: 100,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            display: false,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        };
        options.interaction = {
          intersect: false,
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "average",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabelsModal[tooltipItems[0].dataIndex];
            },
          },
        };
        options.plugins.legend = {
          display: true,
          position: "bottom",
          labels: {
            padding: 22,
            boxHeight: 1,
            boxWidth: 20,
            font: {
              size: 10,
              style: "normal",
            },
            color: "rgba(0, 0, 0, 0.6)",
          },
          title: {
            display: true,
            font: {
              size: 6,
            },
            text: "",
          },
        };
        options.datasets.line = {
          borderWidth: 1,
          pointBorderWidth: 1,
          pointHoverRadius: 3,
          pointRadius: 0,
          pointBorderColor: "rgba(0, 0, 0, 0)",
        };
        // this.loadingModalChartStatus = false;
        var ctx = chart.getContext("2d");
        const label = [];
        for (let i = 0; i < this.dataBarChartModal.activeuser.length; i++) {
          label.push("");
        }
        const data = [
          {
            label: "FEEDBACK",
            data: this.dataBarChartModal["feedback"],
            backgroundColor: "#6C30CC",
            borderColor: "#6C30CC",
          },
          {
            label: "WELLNESS",
            data: this.dataBarChartModal["wellness"],
            backgroundColor: "#148319",
            borderColor: "##148319",
          },
          {
            label: "REL. MANAGER",
            data: this.dataBarChartModal["manager"],
            backgroundColor: "#3756D8",
            borderColor: "#3756D8",
          },
          {
            label: "RECOGNITION",
            data: this.dataBarChartModal["recognition"],
            backgroundColor: "#F7992B",
            borderColor: "#F7992B",
          },
          {
            label: "AMBASSADO.",
            data: this.dataBarChartModal["ambassadorship"],
            backgroundColor: "#E522B0",
            borderColor: "#E522B0",
          },
          {
            label: "REL. COLLEA.",
            data: this.dataBarChartModal["colleagues"],
            backgroundColor: "#32C2D5",
            borderColor: "#32C2D5",
          },
          {
            label: "P. GROWTH",
            data: this.dataBarChartModal["personal"],
            backgroundColor: "#E5BE75",
            borderColor: "#E5BE75",
          },
          {
            label: "CO. ALIGN.",
            data: this.dataBarChartModal["alignment"],
            backgroundColor: "#D02D21",
            borderColor: "#D02D21",
          },
          {
            label: "SATISFACTION",
            data: this.dataBarChartModal["satisfaction"],
            backgroundColor: "#6C30CC",
            borderColor: "#6C30CC",
          },
        ];
        this.myModalLineChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: label,
            datasets: data,
          },
          options: options,
        });
        this.chartInModalNodataStatus = false; // Show UI no data on here!
      } else {
        // this.loadingModalChartStatus = false;
      }
    },
    remoteMainPage(rows, callback) {
      setTimeout(() => {
        var response = [];
        if (this.selectMainPageSort == "1") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["desc"]
          );
        } else if (this.selectMainPageSort == "2") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["asc"]
          );
        } else if (this.selectMainPageSort == "3") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["desc"]
          );
        } else {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["asc"]
          );
        }
        callback(response);
      }, 300);
    },
    remoteModal(rows, callback) {
      setTimeout(() => {
        var response = [];
        if (this.selectModalSort == "1") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["desc"]
          );
        } else if (this.selectModalSort == "2") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["asc"]
          );
        } else if (this.selectModalSort == "3") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["desc"]
          );
        } else {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["asc"]
          );
        }
        callback(response);
      }, 300);
    },
    showModal(key) {
      this.$store.commit("teams/setLoadingDataModal", true);
      this.selectTeamModal = key !== "all" ? key : "";
      this.activeWhereModal = this.activeWhere;
      this.selectModalMonth = this.selectMainPageMonth;
      this.optionsModalMonthName = this.optionsMainPageMonthName;
      this.optionsModalMonth = this.optionsMainPageMonth;
      this.newLabelsModal = this.newLabels;
      this.newLabelsModalfulldate = this.newLabels;
      this.$store.commit(
        "teams/setSelectMonthModal",
        this.optionsMainPageMonth
      );
      this.handleTeamsModal(key);
      this.spotlightTeamStatus = true;
    },
    async changMainPageData(key) {
      this.$store.commit("teams/setLoadingData", true);
      this.teamStatusChanged = true;
      this.dataMainPageChanged = true;
      this.selectTeam = key;
      await this.handleTeams(key);
    },
    handleTeamsModal(key) {
      // this.loadingModalChartStatus = true;
      this.modalTitle = key;
      const team = key !== "all" ? key : "";
      this.$store.commit("teams/setChartHappyRiskModal", []);
      this.$store.commit("teams/setDataTableModal", []);
      this.$store.commit("teams/setTeamModal", key);
      this.$store.dispatch("teams/getInsightTeamsModal", {
        selectTeam: team,
        activeWhere: this.activeWhereModal,
      });
      this.$store.dispatch("teams/searchSpotlightByTeamModal", team);
      this.$refs.teamsTable.store.states._treeRowExpanded = [];
      this.$store.dispatch("teams/getDataTablebyTeamModal", {
        team,
        type: "parent",
      });
      this.dataModalTreeTable();
    },
    handleTeams(key) {
      // this.loadingModalChartStatus = true;
      this.modalTitle = key;
      const team = key !== "all" ? key : "";
      this.$store.commit("teams/setChartHappyRisk", []);
      this.$store.commit("teams/setDataTable", []);
      this.$store.commit("teams/setTeam", key);
      this.$store.dispatch("teams/getInsightTeams", {
        selectTeam: team,
        activeWhere: this.activeWhere,
      });
      this.$store.dispatch("teams/searchSpotlightByTeam", team);
      this.$refs.teamsTable.store.states._treeRowExpanded = [];
      this.$store.dispatch("teams/getDataTablebyTeam", {
        team,
        type: "parent",
      });
      this.$forceUpdate()
    },
    handleMainPageMonth(optMonth) {
      this.$store.commit("teams/setLoadingData", true);
      this.dataMainPageChanged = true;
      const newDate = new Date();
      let textOption = this.$t("insights.Last_24_months");
      this.optionsMainPageMonthName = [];
      this.optionsMainPageMonth = [];
      this.newLabels = [];
      this.newLabelsfulldate = [];
      this.activeWhere = {};
      if (optMonth == "30-days") {
        textOption = this.$t("insights.Last_30_days");
        this.activeWhere = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -30), "YYYY-MM-DD"),
        };
        newDate.setDate(newDate.getDate() - 1);
        for (let i = 30; i > 0; i--) {
          const m = this.$dateFns.format(
            subMonths(newDate, -(i - 1)),
            "YYYY-MM"
          );
          const d = getDaysInMonth(m);
          const day = getDay(
            this.$dateFns.format(addDays(newDate, -(i - 1)), "YYYY-MM-DD")
          );
          if (day != 0 && day != 6) {
            if (i % 7 === 0) {
              this.optionsMainPageMonthName.push(
                this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
              );
            } else {
              this.optionsMainPageMonthName.push("");
            }
            this.newLabels.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
            );
            this.newLabelsfulldate.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMMM")
            );
            const daterange = {
              startdate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
              enddate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
            };
            this.optionsMainPageMonth.push(daterange);
          }
        }
      } else if (optMonth == "60-days") {
        textOption = this.$t("insights.Last_60_days");
        this.activeWhere = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -60), "YYYY-MM-DD"),
        };
        newDate.setDate(newDate.getDate() - 1);
        for (let i = 60; i > 0; i--) {
          const m = this.$dateFns.format(
            subMonths(newDate, -(i - 1)),
            "YYYY-MM"
          );
          const d = getDaysInMonth(m);
          const day = getDay(
            this.$dateFns.format(addDays(newDate, -(i - 1)), "YYYY-MM-DD")
          );
          if (day != 0 && day != 6) {
            if (i % 7 === 0) {
              this.optionsMainPageMonthName.push(
                this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
              );
            } else {
              this.optionsMainPageMonthName.push("");
            }
            this.newLabels.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
            );
            this.newLabelsfulldate.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMMM")
            );
            const daterange = {
              startdate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
              enddate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
            };
            this.optionsMainPageMonth.push(daterange);
          }
        }
      } else if (
        optMonth == "13-weeks" ||
        optMonth == "26-weeks" ||
        optMonth == "52-weeks"
      ) {
        let week = 13;
        if (optMonth == "13-weeks") {
          textOption = this.$t("insights.Last_13_weeks");
        } else if (optMonth == "26-weeks") {
          textOption = this.$t("insights.Last_26_weeks");
          week = 26;
        } else {
          textOption = this.$t("insights.Last_52_weeks");
          week = 52;
        }
        let new_Date = this.$dateFns.format(
          addDays(startOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );
        let last_dayof_week = this.$dateFns.format(
          addDays(lastDayOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );
        for (let j = week - 1; j >= 0; j--) {
          let daterange = {};
          let startweek = this.$dateFns.format(
            subWeeks(new_Date, j),
            "YYYY-MM-DD"
          );
          let lastweek = this.$dateFns.format(
            subWeeks(last_dayof_week, j),
            "YYYY-MM-DD"
          );

          daterange = {
            startdate: startweek,
            enddate: lastweek,
          };
          this.optionsMainPageMonth.push(daterange);
          this.optionsMainPageMonthName.push(
            this.$dateFns.format(startweek, "D MMM").toUpperCase()
          );
          this.newLabels.push(this.$dateFns.format(startweek, "DD MMM"));
          this.newLabelsfulldate.push(
            this.$dateFns.format(startweek, "DD MMMM")
          );
        }
        if (this.optionsMainPageMonth.length) {
          this.activeWhere = {
            type: "weeks",
            start: this.optionsMainPageMonth[0].startdate,
          };
        }
      } else {
        textOption = this.$t("insights.Last_24_months");
        for (let i = 23; i >= 0; i--) {
          const datenow =
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM") + "-31";
          this.optionsMainPageMonthName.push(
            this.$dateFns.format(addMonths(newDate, -i), "MMM").toUpperCase()
          );
          const daterange = {
            startdate:
              this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM") + "-01",
            enddate: datenow,
          };
          this.optionsMainPageMonth.push(daterange);
          this.newLabels.push(
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM")
          );
          this.newLabelsfulldate.push(
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM")
          );
        }
        if (this.optionsMainPageMonth.length) {
          this.activeWhere = {
            type: "months",
            start: this.optionsMainPageMonth[0].startdate,
          };
        }
      }
      this.selectMainPageMonth = textOption;
      if (this.optionsMainPageMonth.length > 0 && !this.loadingDataListTable) {
        this.$store.commit("teams/setChartHappyRisk", []);
        this.$store.commit("teams/setSelectMonth", this.optionsMainPageMonth);
        this.$store.dispatch("teams/getDataChart", {
          value: this.optionsMainPageMonth,
          activeWhere: this.activeWhere,
        });
      }
    },
    handleModalMonth(optMonth) {
      const newDate = new Date();
      let textOption = this.$t("insights.Last_24_months");
      this.optionsModalMonthName = [];
      this.optionsModalMonth = [];
      this.newLabelsModal = [];
      this.newLabelsModalfulldate = [];
      this.activeWhereModal = {};
      if (optMonth == "30-days") {
        textOption = this.$t("insights.Last_30_days");
        this.activeWhereModal = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -30), "YYYY-MM-DD"),
        };
        newDate.setDate(newDate.getDate() - 1);
        for (let i = 30; i > 0; i--) {
          const m = this.$dateFns.format(
            subMonths(newDate, -(i - 1)),
            "YYYY-MM"
          );
          const d = getDaysInMonth(m);
          const day = getDay(
            this.$dateFns.format(addDays(newDate, -(i - 1)), "YYYY-MM-DD")
          );
          if (day != 0 && day != 6) {
            if (i % 7 === 0) {
              this.optionsModalMonthName.push(
                this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
              );
            } else {
              this.optionsModalMonthName.push("");
            }
            this.newLabelsModal.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
            );
            this.newLabelsModalfulldate.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMMM")
            );
            const daterange = {
              startdate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
              enddate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
            };
            this.optionsModalMonth.push(daterange);
          }
        }
      } else if (optMonth == "60-days") {
        textOption = this.$t("insights.Last_60_days");
        this.activeWhereModal = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -60), "YYYY-MM-DD"),
        };
        newDate.setDate(newDate.getDate() - 1);
        for (let i = 60; i > 0; i--) {
          const m = this.$dateFns.format(
            subMonths(newDate, -(i - 1)),
            "YYYY-MM"
          );
          const d = getDaysInMonth(m);
          const day = getDay(
            this.$dateFns.format(addDays(newDate, -(i - 1)), "YYYY-MM-DD")
          );
          if (day != 0 && day != 6) {
            if (i % 7 === 0) {
              this.optionsModalMonthName.push(
                this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
              );
            } else {
              this.optionsModalMonthName.push("");
            }
            this.newLabelsModal.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMM")
            );
            this.newLabelsModalfulldate.push(
              this.$dateFns.format(addDays(newDate, -(i - 1)), "DD MMMM")
            );
            const daterange = {
              startdate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
              enddate: this.$dateFns.format(
                addDays(newDate, -(i - 1)),
                "YYYY-MM-DD"
              ),
            };
            this.optionsModalMonth.push(daterange);
          }
        }
      } else if (
        optMonth == "13-weeks" ||
        optMonth == "26-weeks" ||
        optMonth == "52-weeks"
      ) {
        let week = 11;
        if (optMonth == "13-weeks") {
          textOption = this.$t("insights.Last_13_weeks");
        } else if (optMonth == "26-weeks") {
          textOption = this.$t("insights.Last_26_weeks");
          week = 14;
        } else {
          textOption = this.$t("insights.Last_52_weeks");
          week = 50;
        }
        for (let i = week; i > 0; i--) {
          let m = -7 * i;
          this.optionsModalMonthName.push(
            this.$dateFns.format(setDay(newDate, -6 + m), "D MMM").toUpperCase()
          );
          const datenow = this.$dateFns.format(
            setDay(newDate, -6 + m),
            "YYYY-MM-DD"
          );
          const daterange = {
            startdate: this.$dateFns.format(setDay(datenow, -6), "YYYY-MM-DD"),
            enddate: datenow,
          };
          this.optionsModalMonth.push(daterange);
          this.newLabelsModal.push(this.$dateFns.format(datenow, "DD MMM"));
          this.newLabelsModalfulldate.push(
            this.$dateFns.format(datenow, "DD MMMM")
          );
        }
        this.optionsModalMonthName.push(
          this.$dateFns.format(setDay(newDate, -6), "D MMM").toUpperCase()
        );
        this.optionsModalMonthName.push(
          this.$dateFns.format(setDay(newDate, 1), "D MMM").toUpperCase()
        );

        const datenow1 = this.$dateFns.format(
          setDay(newDate, -6),
          "YYYY-MM-DD"
        );
        const daterange1 = {
          startdate: this.$dateFns.format(setDay(datenow1, -6), "YYYY-MM-DD"),
          enddate: datenow1,
        };
        this.newLabelsModal.push(this.$dateFns.format(datenow1, "DD MMM"));
        this.newLabelsModalfulldate.push(
          this.$dateFns.format(datenow1, "DD MMMM")
        );
        this.optionsModalMonth.push(daterange1);
        const datenow2 = this.$dateFns.format(setDay(newDate, 1), "YYYY-MM-DD");
        const daterange2 = {
          startdate: this.$dateFns.format(setDay(datenow2, -6), "YYYY-MM-DD"),
          enddate: datenow2,
        };
        this.newLabelsModal.push(this.$dateFns.format(datenow2, "DD MMM"));
        this.newLabelsModalfulldate.push(
          this.$dateFns.format(datenow2, "DD MMMM")
        );
        this.optionsModalMonth.push(daterange2);
        if (this.optionsModalMonth.length) {
          this.activeWhereModal = {
            type: "weeks",
            start: this.optionsModalMonth[0].startdate,
          };
        }
      } else {
        textOption = "Last 24 months";
        for (let i = 23; i >= 0; i--) {
          const datenow =
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM") + "-31";
          this.optionsModalMonthName.push(
            this.$dateFns.format(addMonths(newDate, -i), "MMM").toUpperCase()
          );
          const daterange = {
            startdate:
              this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM") + "-01",
            enddate: datenow,
          };
          this.optionsModalMonth.push(daterange);
          this.newLabelsModal.push(
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM")
          );
          this.newLabelsModalfulldate.push(
            this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM")
          );
        }
        if (this.optionsModalMonth.length) {
          this.activeWhereModal = {
            type: "months",
            start: this.optionsModalMonth[0].startdate,
          };
        }
      }
      this.selectModalMonth = textOption;
      if (this.optionsModalMonth.length > 0) {
        this.$store.commit("teams/setChartHappyRiskModal", []);
        this.$store.commit("teams/setSelectMonth", this.optionsModalMonth);
        this.$store.dispatch("teams/getDataChartModal", {
          value: this.optionsModalMonth,
          activeWhere: this.activeWhereModal,
        });
      }
    },
    sortByMainPage(row) {
      this.selectMainPageSort = row.index;
      this.dataMainTreeTable();
    },
    async sortByModal(row) {
      this.selectModalSort = row.index;
      this.$store.commit("teams/setSortModal", this.selectModalSort);
      await this.handleSort(row);
      this.dataModalTreeTable();
    },
    handleSort(row) {
      this.$store.commit("teams/setDataTableModal", []);
      const team = this.selectTeamModal !== "all" ? this.selectTeamModal : "";
      this.$refs.teamsTable.store.states._treeRowExpanded = [];
      this.$store.dispatch("teams/getDataTablebyTeamModal", {
        team,
        type: "parent",
        sort: this.selectModalSort,
      });
    },
    generateChartTooltipOnMainEngagement() {
      let value = this.hoverTeam
      let chart = this.$refs['engagement_'+value.id];
      if(chart){
        var tooltipBarChart = this.$refs['engagement_'+value.id];
        if (tooltipBarChart) {
          const tooltipBarchartDataResigned = {
            labels: this.databarchartEngagementScore['labels'],
            datasets: [
              {
                data: this.databarchartEngagementScore['team'],
                borderColor: "#00ACC1",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#00ACC14A");
                    gradientFill.addColorStop(1, "#00ACC100");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['manager'],
                borderColor: "#E45006",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#E450064A");
                    gradientFill.addColorStop(1, "#E4500600");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['leader'],
                borderColor: "#D532C2",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#D532C24A");
                    gradientFill.addColorStop(1, "#D532C200");
                    return gradientFill;
                },
              },
            ],
          };
          this.barChartTooltipBarChartOnMainEngagement = new Chart(
            tooltipBarChart.getContext("2d"),
            {
              type: "line",
              data: tooltipBarchartDataResigned,
              options: {
                interaction: {
                  intersect: false,
                  mode: 'nearest'
                },
                maintainAspectRatio: false,
                scales: {
                  y: {
                    min: 0,
                    display: false,
                    ticks: {
                      stepSize: 50,
                      callback: function (value) {
                        return value;
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      font: {
                        color: 'black',
                        size: 12,
                        weight: 'bold',
                        family: 'Lato'
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    formatter: function (value, context) {
                      return value;
                    },
                    font: {
                      weight: "bold",
                      size: 10,
                    },
                  },
                  tooltip: {
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                      title: (tooltipItems) => {
                        return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                      },
                      label: function (tooltipItems) {
                        const value = tooltipItems.formattedValue;
                        if(tooltipItems.datasetIndex == 0){
                          return ` Overall : ${value}`;
                        }else if(tooltipItems.datasetIndex == 1){
                          return ` Manager : ${value}`;
                        }else if(tooltipItems.datasetIndex == 2){
                          return ` Leader : ${value}`;
                        }
                      },
                    },
                    titleFont: {
                      weight: 'bold',
                    },
                  },
                },
                elements: {
                  line: {
                    tension: 0,
                  },
                },
                responsive: true,
                animations: false,
              },
            }
          );
        }
      }
    },
    generateChartTooltipOnModalEngagement() {
      let value = this.hoverModalTeam
      let chart = this.$refs['engagement_modal_'+value.id];
      if(chart){
        var tooltipBarChart = this.$refs['engagement_modal_'+value.id];
        if (tooltipBarChart) {
          const tooltipBarchartDataResigned = {
            labels: this.databarchartEngagementScoreModal['labels'],
            datasets: [
              {
                data: this.databarchartEngagementScoreModal['team'],
                borderColor: "#00ACC1",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#00ACC14A");
                    gradientFill.addColorStop(1, "#00ACC100");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScoreModal['manager'],
                borderColor: "#E45006",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#E450064A");
                    gradientFill.addColorStop(1, "#E4500600");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScoreModal['leader'],
                borderColor: "#D532C2",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#D532C24A");
                    gradientFill.addColorStop(1, "#D532C200");
                    return gradientFill;
                },
              },
            ],
          };
          this.barChartTooltipBarChartOnModalEngagement = new Chart(
            tooltipBarChart.getContext("2d"),
            {
              type: "line",
              data: tooltipBarchartDataResigned,
              options: {
                interaction: {
                  intersect: false,
                  mode: 'nearest'
                },
                maintainAspectRatio: false,
                scales: {
                  y: {
                    min: 0,
                    display: false,
                    ticks: {
                      stepSize: 50,
                      callback: function (value) {
                        return value;
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      font: {
                        color: 'black',
                        size: 12,
                        weight: 'bold',
                        family: 'Lato'
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    formatter: function (value, context) {
                      return value;
                    },
                    font: {
                      weight: "bold",
                      size: 10,
                    },
                  },
                  tooltip: {
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                      title: (tooltipItems) => {
                        return this.databarchartEngagementScoreModal['newLabels'][tooltipItems[0].dataIndex];
                      },
                      label: function (tooltipItems) {
                        const value = tooltipItems.formattedValue;
                        if(tooltipItems.datasetIndex == 0){
                          return ` Overall : ${value}`;
                        }else if(tooltipItems.datasetIndex == 1){
                          return ` Manager : ${value}`;
                        }else if(tooltipItems.datasetIndex == 2){
                          return ` Leader : ${value}`;
                        }
                      },
                    },
                    titleFont: {
                      weight: 'bold',
                    },
                  },
                },
                elements: {
                  line: {
                    tension: 0,
                  },
                },
                responsive: true,
                animations: false,
              },
            }
          );
        }
      }
    },
    generateChartTooltipOnMain(value) {
      //console.log("generateChartTooltipOnMain", value);
      if (this.barChartTooltipBarChartOnMain) {
        this.barChartTooltipBarChartOnMain.destroy();
      }
      let chartLabel = [];
             // TODO: Add data to chart here!
      let chartDataResigned = []; // TODO: Add data to chart here!
      let chartDataTerminated = []; // TODO: Add data to chart here!
      let chartDataAll = []; // TODO: Add data to chart here!
      for(let i=5;i>=0;i--){
        chartLabel.push( this.$dateFns.format(addMonths(new Date(), -i), 'MMM'))
        const dateKey=this.$dateFns.format(addMonths(new Date(), -i), 'YYYY-MM')

        chartDataResigned.push(value.resigned[dateKey]?value.resigned[dateKey]:0)
        chartDataTerminated.push(value.terminate[dateKey]?value.terminate[dateKey]:0)
        chartDataAll.push(isNaN(value.resigned[dateKey]+value.terminate[dateKey])?0:value.resigned[dateKey]+value.terminate[dateKey])
      }

      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      // let type = this.getTypeOfData(this.rowSelected);
      var tooltipBarChart = this.$refs[value.id];
      // const width = (chartBarColor.length * 48 || 0) + 165;
      // this.widthOfPopup = `width: ${width}px;`;
      options.plugins.datalabels = {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value, context) {
          return context.dataset.sumData[context.dataIndex];
        },
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
          stacked: true,
        },
        x: {
          stacked: true,
        },
      };
      options.animations = false;

      if (tooltipBarChart) {
        this.loadingChartInTable = false;
        const blankAll = [];
        chartDataTerminated.forEach((item, index) => {
          if (item > 0) {
            blankAll.push("");
          } else {
            blankAll.push(chartDataAll[index]);
          }
        });
        const tooltipBarchartDataResigned = {
          labels: chartLabel,
          datasets: [
            {
              data: chartDataResigned,
              sumData: blankAll,
              backgroundColor: "#F44336",
              stack: "Stack 0",
              borderRadius: 0,
            },
            {
              data: chartDataTerminated,
              sumData: chartDataAll,
              backgroundColor: "#FFBCB7",
              stack: "Stack 0",
              borderRadius: 0,
            },
          ],
        };
        this.barChartTooltipBarChartOnMain = new Chart(
          tooltipBarChart.getContext("2d"),
          {
            plugins: [chartDataResignedLabels],
            type: "bar",
            data: tooltipBarchartDataResigned,
            options: options,
          }
        );
      }
    },
    generateChartTooltipOnModal(value) {
      if (this.barChartTooltipBarChartOnModal) {
        this.barChartTooltipBarChartOnModal.destroy();
      }

      // console.log("@TODO: Add data to chart", value);
      // let chartLabel = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"]; // TODO: Add data to chart here!
      // let chartDataResigned = [6, 7, 8, 7, 5, 8]; // TODO: Add data to chart here!
      // let chartDataTerminated = [0, 2, 0, 0, 1, 2]; // TODO: Add data to chart here!
      // let chartDataAll = [6, 9, 8, 7, 6, 10]; // TODO: Add data to chart here!
      let chartLabel = [];// TODO: Add data to chart here!
      let chartDataResigned = []; // TODO: Add data to chart here!
      let chartDataTerminated = []; // TODO: Add data to chart here!
      let chartDataAll = []; // TODO: Add data to chart here!
      for(let i=5;i>=0;i--){
        chartLabel.push( this.$dateFns.format(addMonths(new Date(), -i), 'MMM'))
        const dateKey=this.$dateFns.format(addMonths(new Date(), -i), 'YYYY-MM')

        chartDataResigned.push(value.resigned[dateKey]?value.resigned[dateKey]:0)
        chartDataTerminated.push(value.terminate[dateKey]?value.terminate[dateKey]:0)
        chartDataAll.push(isNaN(value.resigned[dateKey]+value.terminate[dateKey])?0:value.resigned[dateKey]+value.terminate[dateKey])
      }

      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      // let type = this.getTypeOfData(this.rowSelected);
      var tooltipBarChart = this.$refs["modal_" + value.id];
      // const width = (chartBarColor.length * 48 || 0) + 165;
      // this.widthOfPopup = `width: ${width}px;`;
      options.plugins.datalabels = {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value, context) {
          return context.dataset.sumData[context.dataIndex];
        },
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
          stacked: true,
        },
        x: {
          stacked: true,
        },
      };
      options.animations = false;

      if (tooltipBarChart) {
        this.loadingChartInTable = false;
        const blankAll = [];
        chartDataTerminated.forEach((item, index) => {
          if (item > 0) {
            blankAll.push("");
          } else {
            blankAll.push(chartDataAll[index]);
          }
        });
        const tooltipBarchartDataResigned = {
          labels: chartLabel,
          datasets: [
            {
              data: chartDataResigned,
              sumData: blankAll,
              backgroundColor: "#F44336",
              stack: "Stack 0",
              borderRadius: 0,
            },
            {
              data: chartDataTerminated,
              sumData: chartDataAll,
              backgroundColor: "#FFBCB7",
              stack: "Stack 0",
              borderRadius: 0,
            },
          ],
        };
        this.barChartTooltipBarChartOnModal = new Chart(
          tooltipBarChart.getContext("2d"),
          {
            plugins: [chartDataResignedLabels],
            type: "bar",
            data: tooltipBarchartDataResigned,
            options: options,
          }
        );
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 6) {
        return `
          background-image: linear-gradient(to bottom, #6C30CC 40%, rgba(255, 255, 255, 0) 20%);
          background-position: right;
          background-size: 1px 9px;
          background-repeat: repeat-y;
          padding-top: 7px;
        `;
      } else if (columnIndex == 12 || columnIndex == 13) {
        return "padding: 7px 6px;";
      } else {
        return "padding-top: 7px;";
      }
      // if (columnIndex == 2) {
      //   if (rowIndex == 0) {
      //     return "font-size: 16px; padding-top: 12px;";
      //   } else {
      //     return "font-size: 16px;";
      //   }
      // } else if (columnIndex > 6 && columnIndex < 12) {
      //   if (rowIndex == 0) {
      //     if (columnIndex == 7) {
      //       return "background-color: #F2F2F2; border-top-left-radius: 10px; padding-top: 12px;";
      //     } else if (columnIndex == 11) {
      //       return "background-color: #F2F2F2; border-top-right-radius: 10px; padding-top: 12px;";
      //     } else {
      //       return "background-color: #F2F2F2; padding-top: 12px;";
      //     }
      //   } else {
      //     return "background-color: #F2F2F2;";
      //   }
      // } else {
      //   if (rowIndex == 0) {
      //     return "padding-top: 12px;";
      //   }
      // }
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    truncateText(text, maxLength) {
      let length = maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    findTeamNameByKey(key) {
      if (key && this.optionsTeam) {
        for (let i = 0; i < this.optionsTeam.length; i++) {
          if (key === this.optionsTeam[i].key) {
            return this.optionsTeam[i].name;
          }
        }
      } else {
        return "";
      }
    },
    async exportChart(table) {
      if (table == "modal") {
        this.$store.dispatch("teams/getDataGraphExport", {
          table: table,
          activeWhere: this.activeWhere,
          filter: this.selectModalMonth,
          labeldate: this.newLabelsModalfulldate,
        });
      } else {
        this.$store.dispatch("teams/getDataGraphExport", {
          table: table,
          activeWhere: this.activeWhere,
          filter: this.selectMainPageMonth,
          labeldate: this.newLabelsfulldate,
        });
      }
    },
    compare(a, b) {
      let sortingBy = "happirate";
      let sortType = "asce"; // lowest
      if (a && b) {
        if (this.selectMainPageSort == "3") {
          sortingBy = "riskrate";
          sortType = "desc";
        } else if (this.selectMainPageSort == "2") {
          sortingBy = "riskrate";
          sortType = "asce";
        } else if (this.selectMainPageSort == "1") {
          sortingBy = "happirate";
          sortType = "desc";
        } else {
          sortingBy = "happirate";
          sortType = "asce";
        }
        const sortA = a[sortingBy];
        const sortB = b[sortingBy];

        let comparison = 0;
        if (sortA > sortB) {
          comparison = 1;
        } else if (sortA < sortB) {
          comparison = -1;
        }
        if (sortType === "desc") {
          comparison = comparison * -1;
        }
        return comparison;
      } else {
        return undefined;
      }
    },
    compareModal(a, b) {
      let sortingBy = "happirate";
      let sortType = "asce"; // lowest
      if (a && b) {
        if (this.selectModalSort == "3") {
          sortingBy = "riskrate";
          sortType = "desc";
        } else if (this.selectModalSort == "2") {
          sortingBy = "riskrate";
          sortType = "asce";
        } else if (this.selectModalSort == "1") {
          sortingBy = "happirate";
          sortType = "desc";
        } else {
          sortingBy = "happirate";
          sortType = "asce";
        }
        const sortA = a[sortingBy];
        const sortB = b[sortingBy];

        let comparison = 0;
        if (sortA > sortB) {
          comparison = 1;
        } else if (sortA < sortB) {
          comparison = -1;
        }
        if (sortType === "desc") {
          comparison = comparison * -1;
        }
        return comparison;
      } else {
        return undefined;
      }
    },
    deleteChild() {
      let objCount = Object.keys(this.realDataMainTreeTable).length;
      if (objCount === 1 && this.realDataMainTreeTable[0].child_num > 0) {
        this.realDataMainTreeTable[0].children =
          this.realDataMainTreeTable[0].children.sort(this.compare);
        for (
          let i = 0;
          i < this.realDataMainTreeTable[0].children.length;
          i++
        ) {
          if (this.realDataMainTreeTable[0].children[i].children) {
            delete this.realDataMainTreeTable[0].children[i].children;
            this.realDataMainTreeTable[0].children[i].hasChildren = true;
          }
        }
      }
    },
    deleteModalChild() {
      let objCount = Object.keys(this.realDataModalTreeTable).length;
      if (objCount === 1 && this.realDataModalTreeTable[0].child_num > 0) {
        this.realDataModalTreeTable[0].children =
          this.realDataModalTreeTable[0].children.sort(this.compareModal);
        for (
          let i = 0;
          i < this.realDataModalTreeTable[0].children.length;
          i++
        ) {
          if (this.realDataModalTreeTable[0].children[i].children) {
            delete this.realDataModalTreeTable[0].children[i].children;
            this.realDataModalTreeTable[0].children[i].hasChildren = true;
          }
        }
      }
    },
    dataMainTreeTable() {
      let obj = [];
      obj = _.clone(this.dataAllList);
      this.loadingMainData = true;
      this.realDataMainTreeTable = [];
      let objCount = Object.keys(obj).length;

      if (objCount === 1 && obj[0].child_num > 0) {
        obj[0].children = obj[0].children.sort(this.compare);
        this.expandkay.push(obj[0].id);
      } else if (obj.children) {
        delete this.realDataMainTreeTable.children;
        obj.children = obj.children.sort(this.compare);
      }
      setTimeout(() => {
        this.realDataMainTreeTable = _.cloneDeep(obj);
        this.loadingMainData = false;
        this.deleteChild();
      }, 300);
    },
    dataModalTreeTable() {
      let obj = [];
      obj = _.clone(this.dataAllListModal);
      this.loadingModalData = true;
      this.realDataModalTreeTable = [];
      let objCount = Object.keys(obj).length;

      if (objCount === 1 && obj[0].child_num > 0) {
        obj[0].children = obj[0].children.sort(this.compareModal);
        this.expandkay.push(obj[0].id);
      } else if (obj.children) {
        delete this.realDataModalTreeTable.children;
        obj.children = obj.children.sort(this.compareModal);
      }
      setTimeout(() => {
        this.realDataModalTreeTable = _.cloneDeep(obj);
        this.loadingModalData = false;
        this.deleteModalChild();
      }, 300);
    },
    load(tree, treeNode, resolve) {
      if (tree.children) {
        tree.children = tree.children.sort(this.compare);
        resolve(tree.children);
      } else {
        let childrenTeam = _(this.dataAllList)
          .thru(function (coll) {
            return _.union(coll, _.map(coll, "children") || []);
          })
          .flatten()
          .find({ id: tree.id });

        if (childrenTeam) {
          for (let i = 0; i < childrenTeam.children.length; i++) {
            if (childrenTeam.children[i].child_num > 0) {
              childrenTeam.children[i].hasChildren = true;
            }
          }
          childrenTeam.children = childrenTeam.children.sort(this.compare);
          resolve(childrenTeam.children);
        }
        resolve([]);
      }
    },
    loadModal(tree, treeNode, resolve) {
      if (tree.children) {
        tree.children = tree.children.sort(this.compareModal);
        resolve(tree.children);
      } else {
        let childrenTeam = _(this.dataAllListModal)
          .thru(function (coll) {
            return _.union(coll, _.map(coll, "children") || []);
          })
          .flatten()
          .find({ id: tree.id });

        if (childrenTeam) {
          for (let i = 0; i < childrenTeam.children.length; i++) {
            if (childrenTeam.children[i].child_num > 0) {
              childrenTeam.children[i].hasChildren = true;
            }
          }
          childrenTeam.children = childrenTeam.children.sort(this.compareModal);
          resolve(childrenTeam.children);
        }
        resolve([]);
      }
    },
    renderPhaseHeader(h, { column }) {
      let className = "labelTable rotate";
      return h(
        "div",
        {
          class: className,
        },
        [
          h(
            "div",
            {
              class: "ellipsis left",
              style: "overflow: hidden; width: 110px;",
            },
            column.label
          ),
        ]
      );
    },
    showingHistoryMainTable(value) {
      this.loadingChartInTable = true;
      this.generateChartTooltipOnMain(value);
    },
    showingHistoryModalTable(value) {
      this.loadingChartInTable = true;
      this.generateChartTooltipOnModal(value);
    },
    showingHistoryMainEngagementTable(value) {
      this.hoverTeam = value
      this.$store.dispatch("teams/getTeamEngagementScore", {
        selectTeam: value.id,
      })
    },
    showingHistoryModalEngagementTable(value) {
      this.hoverModalTeam = value
      this.$store.dispatch("teams/getTeamEngagementScoreModal", {
        selectTeam: value.id,
      })
    },
    detectColorTotal(value) {
      if(value == '-'){
        return "gray";
      }else if (value >= 60) {
        return "green";
      } else if (value < 60 && value >= 40) {
        return "yellow";
      } else {
        return "red";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headerCard {
  display: flex;
  margin-top: 24px;
}
.headerCard2 {
  display: flex;
  margin-top: 36px;
}
.txtHeaderCard {
  font-size: 18px;
  font-weight: 700;
}
.txt-spot-card .txtmenuOption {
  font-size: 16px;
}
.txt-spot-card {
  font-size: 16px;
  font-weight: 700;
}
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}
.txtOption2 {
  color: #4a4a4a;
  font-size: 16px;
  margin-left: 16px;
  width: 140px;
  display: inline-block;
}
.divTable {
  flex: 1;
  margin: 38px 0px 38px 0px;
}
.flexCenter {
  align-items: center;
}
.divCurcleStatus {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  background-color: #C7C7C7;
  // padding: 12px;
}
.divCurcleStatus.yellow{
  background-color: #FBC02D;
}
.divCurcleStatus.green{
  background-color: #66BB6A;
}
.divCurcleStatus.red{
  background-color: #F44336;
}
.divCurcleStatus .scorelabel{
  font-size: 11px;
  font-weight: 700;
  line-height: 28px;
  color: #000000;
  display: none;
}
.el-table__row:hover .divCurcleStatus.green{
  background-color: #66BB6A50;
}
.el-table__row:hover .divCurcleStatus.yellow{
  background-color: #FBC02D50;
}
.el-table__row:hover .divCurcleStatus.red{
  background-color: #F4433650;
}
.el-table__row:hover .scorelabel{
  display: block;
}
.SpotBox {
  margin-top: 16px;
  width: 25%;
  box-sizing: border-box;
}
.SpotGroupBox {
  // height: 47px;
  margin-top: 12px;
  // padding-bottom: 6px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.SpotGroupBox .icon-anim {
  transition: transform 0.3s ease-in-out;
}

.SpotGroupBox:hover .icon-anim {
  transform: translateX(6px);
}
.KeyGroupBox {
  margin-top: 6px;
  margin-right: 6px;
  width: 168px;
  height: 48px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  // box-shadow: 0px 2px 4px #00000029;
  box-sizing: border-box;
  overflow: hidden;
  cursor: default;
}
.txtHeaderSpot {
  font-size: 14px;
  opacity: 0.92;
  color: #000000;
  font-weight: 500;
  white-space: nowrap;
}
.txtDetailSpot {
  font-size: 11px;
  color: #000000;
  opacity: 0.7;
  white-space: nowrap;
}
.tooltipStyle {
  width: 218px;
}
.noDataTextStyle {
  font-size: 12px;
  color: #939393;
}
.modal-header {
  background-color: #f2f2f2;
  border-radius: 6px 6px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: #4a4a4a;
}
.chart-bar {
  margin-top: 24px;
  background-color: rgba(0,0,0,0.03);
  border-radius: 24px;
  padding: 32px 24px 0;
}
.loading-chart-bar {
  height: 50px;
  margin-top: 72px;
  margin-bottom: 20px;
}
.chart-type-bar {
  width: 20px;
  height: 15px;
  border-radius: 1px;
}
.chart-type-bar.red {
  border: 1px solid #f44336;
  background-color: #f4433699;
}
.chart-type-bar.green {
  border: 1px solid #66bb6a;
  background-color: #66bb6a98;
}
.chart-type-bar.line {
  border: 1px solid #66bb6a00;
  background-color: #66bb6a00;
  > div {
    height: 2px;
    border-radius: 2px;
    background-color: #6c30cc;
    margin-top: 6px;
  }
}
.type-bar-text {
  color: #000;
  opacity: 0.6;
  font-size: 10px;
  margin: 0 16px 0 6px;
}
.text-open-modal {
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    text-decoration: underline;
  }
}
.chart-legend {
  display: flex;
  padding: 4px 12px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  align-items: center;
  margin: 6px 0 0 12px;
}
.chart-legend.first {
  margin: 6px 0 0 0;
}

.chart-legend .symbol {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 8px;
}

.symbol.blue {
  background-color: #00ACC1;
}

.symbol.orange {
  background-color: #E45006;
}

.symbol.pink {
  background-color: #D532C2;
}

</style>
<style lang="scss">
#insightsTeam > div > div.headerCard > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#insightsTeam > div > div.headerCard2 > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#teamsTable.el-table td {
  border-bottom: 0px solid #e6e5e4 !important;
}
#teamsTable.el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: transparent;
}
// #teamsTable.el-table
//   .el-table__body
//   tr:last-child
//   > td.el-table__cell:nth-last-child(2) {
//   border-bottom-right-radius: 10px;
// }
// #teamsTable.el-table
//   .el-table__body
//   tr:last-child
//   > td.el-table__cell:nth-last-child(6) {
//   border-bottom-left-radius: 10px;
// }
#teamsTable .th {
  .labelTable div {
    overflow: visible;
  }
  .rotate {
    -webkit-transform: 
  /* Magic Numbers */ rotate(320deg);
    transform: 
  /* Magic Numbers */ rotate(320deg);
    width: 60px;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTable.is-leaf {
  padding: 40px 0 20px;
  overflow: unset;
  position: unset;
  > div {
    overflow: unset;
    position: unset;
    width: 100%;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    padding-left: 0px;
    padding-right: 0px;
    .rotate {
      position: unset;
      transform: rotate(315deg);
      width: 45px;
      .left {
        overflow: hidden;
        width: 110px;
        font-size: 12px;
      }
    }
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelRateTable.is-leaf {
  > div {
    font-size: 12px;
    line-height: 15px;
  }
  div.word-break {
    word-break: normal;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelRateTable-spam.is-leaf {
  > div {
    font-size: 12px;
    line-height: 15px;
    padding-left: 6px;
    padding-right: 6px;
  }
  div.word-break {
    word-break: normal;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTeamTable.is-leaf
  > div {
  font-size: 16px;
  width: 325px;
}

#teamsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td.tag
  > div {
  padding: 0;
  margin-left: auto;
}
#teamsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td
  > div {
  color: #000;
  font-weight: 400;
  word-break: unset;
}
#teamsTable .el-table__expand-icon {
  color: #000;
}
#teamsTable .el-table__expanded-cell[class*="cell"] {
  padding: unset;
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > th.line-break
  > div {
  word-break: unset;
}
// #teamsTable
//   > div.el-table__header-wrapper
//   > table
//   > thead
//   > tr
//   > th.line-break
//   > div {
//   word-break: unset;
//   color: red;
// }
#teamsTable.el-table th {
  border: 0;
  padding: 12px 0px 0px 0px;
  background-color: transparent;
}
#teamsTable.el-table td {
  padding: 0px 0px 7px 0px;
  transition: 0.3s;
  &:first-of-type {
    border-radius: 6px 0 0 6px;
  }
  &:last-of-type {
    border-radius: 0 6px 6px 0;
  }
}
#teamsTable.el-table .el-table__body tr {
  transition: 0.3s;
  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.03);
    .text-open-modal {
      text-decoration: underline;
    }
  }
}
#teamModal {
  > .el-dialog__wrapper {
    padding-left: 0px;
  }
  @media only screen and (min-width: 597px) {
    > .el-dialog__wrapper {
      padding-left: 236px;
    }
  }
  @media only screen and (min-width: 1300px) {
    > .el-dialog__wrapper {
      padding-left: 256px;
    }
  }
  .el-dialog {
    width: calc(1024px - 32px);
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0;
    color: #000;
  }
  .el-dialog__headerbtn {
    top: 10px;
  }
  .el-submenu > .el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
  }
  

}
</style>
